export { default, getStaticProps } from 'containers/PrivacyPage/PrivacyPage';
